import React from 'react';
interface MetricCardProps {
  label: string;
  value: string | number;
  unit?: string;
  hint?: string;
  accent?: boolean;
}
export function MetricCard({
  label,
  value,
  unit,
  hint,
  accent = false
}: MetricCardProps) {
  return <div className="flex h-full flex-col rounded-card border border-sand-line bg-white/70 p-2" data-id="element-1157" data-mp="kw7bsvgi7qyb">
      <span className="bee-overline text-[9px] font-bold text-muted" data-id="element-1158" data-mp="fy5vujedk7r2">{label}</span>
      <span className="mt-1 flex items-baseline gap-1" data-id="element-1159" data-mp="3oe8slu3y8c0m">
        <span className={`bee-num text-[26px] font-bold leading-none ${accent ? 'text-gold-deep' : 'text-deep'}`} data-id="element-1160" data-mp="3jee4tzfh02js">
          {value}
        </span>
        {unit && <span className="text-[11px] font-medium text-muted" data-id="element-1161" data-mp="3tck5yetgd4nl">{unit}</span>}
      </span>
      {hint && <span className="mt-auto pt-1 text-[10.5px] leading-snug text-muted" data-id="element-1162" data-mp="1dl5ze83eblb0">
          {hint}
        </span>}
    </div>;
}